export const doNotLazyLoad = (img) => {
    img.classList.add('nolazyload')
    img.classList.remove('lazyloading')
    img.classList.add('lazyloaded')
}

export const decodeEntities = (html) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};